import { useQuery } from '@tanstack/react-query';
import { useAppDispatch } from 'App/ReduxProvider/store';
import merchantService from 'commons/services/merchantService/merchantService';
import { setKycFlagsAction } from 'redux/slices/storeInfoSlice';

export const useSyncKycFlags = () => {
  const dispatch = useAppDispatch();

  return useQuery({
    queryKey: ['kycFlagsSync'],
    queryFn: () => merchantService.syncKycFlags(),
    onSuccess: (freshFlags) => {
      dispatch(setKycFlagsAction(freshFlags));
    },
  });
};
